import React, { useEffect } from 'react';
import { ErrorSplash } from '@shared/components';
import { useTranslation } from '@shared/core';
import { withWindow } from '@shared/utils/withWindow';
import { useCardTelemetry } from '@apps/card/Card.telemetry';

export const Error: React.FC<{ orderNumber: string }> = ({ orderNumber }) => {
  const { t } = useTranslation('stationery');
  const tError = t('premiumDigitalRecipientViewError');
  const telemetry = useCardTelemetry();

  useEffect(() => {
    telemetry.premiumDigitalRecipientViewError({ orderNumber });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigateToFindCouple = () => {
    withWindow(global => {
      global.location.href = '/find';
    });
  };

  return (
    <ErrorSplash
      customError={{
        title: tError.title(),
        subtitle: tError.subtitle(),
        linkText: tError.linkText(),
      }}
      handleAction={handleNavigateToFindCouple}
    />
  );
};
